export default function Status({ items }) {
    return <div className="status">You have {items} items on your list</div>;
}
